import React from 'react';
import { Users, FileText, Shield } from 'lucide-react';
import CTASection from '../../components/CTASection';

const TrademarkTransferPage = () => {
  return (
    <div>
      <div className="bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl font-bold mb-6">Trademark <span className="text-[#168356]">Change of Ownership</span></h1>
          <p className="text-xl text-gray-300 max-w-3xl">Transfer trademark ownership through sale, merger, or business restructuring with proper legal documentation.</p>
        </div>
      </div>
      <div className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto space-y-6 text-lg text-gray-700">
            <p>Trademark ownership changes require proper documentation and USPTO recording to maintain legal protection. Whether selling your business, merging with another company, or restructuring your organization, we handle the entire transfer process.</p>
            <p>We prepare assignment agreements, record changes with the USPTO, update trademark certificates, and ensure continuous protection throughout the transition. Proper documentation protects both parties and maintains the trademark's legal status.</p>
          </div>
        </div>
      </div>
      <div className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-6 text-center">
              <FileText className="w-12 h-12 text-[#168356] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Assignment Agreements</h3>
              <p className="text-gray-700">Legally binding documents transferring trademark rights</p>
            </div>
            <div className="bg-white rounded-xl p-6 text-center">
              <Users className="w-12 h-12 text-[#168356] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">USPTO Recording</h3>
              <p className="text-gray-700">Official recording of ownership change with federal government</p>
            </div>
            <div className="bg-white rounded-xl p-6 text-center">
              <Shield className="w-12 h-12 text-[#168356] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Continuous Protection</h3>
              <p className="text-gray-700">Maintain trademark rights throughout transition process</p>
            </div>
          </div>
        </div>
      </div>
      <CTASection />
    </div>
  );
};

export default TrademarkTransferPage;